export function isImage(extension) {
    switch (extension) {
        case "jpg":
        case "jpeg":
        case "gif":
        case "png":
        case "bmp":
        case "tiff":
        case "pcx":
        case "svg":
        case "ico":
            return true;
        default:
            return false;
    }
}
//# sourceMappingURL=upload.js.map